import { resolveInvoiceStatus } from "./invoices";

/**
 * Summary-screen action visibility per invoice lifecycle status.
 */
export function getInvoiceSummaryActions(status, options = {}) {
  const resolved = resolveInvoiceStatus(status);
  const hasUnreversedPayment = options.hasUnreversedPayment === true;
  const outstandingKnown = Number.isInteger(options.outstandingCents);
  const canRecordPayment =
    resolved === "sent" &&
    (!outstandingKnown || options.outstandingCents > 0);

  return {
    editTax: resolved === "draft",
    editNotes: resolved === "draft",
    editInvoiceNumber: resolved === "draft",
    editClientReference: resolved === "draft",
    previewInvoice: true,
    exportPdf: false,
    markSent: false,
    markPaid: canRecordPayment,
    reversePayment: false,
    reopenToDraft: resolved === "sent" && !hasUnreversedPayment,
    archive: resolved === "sent" || resolved === "paid",
    deleteDraft: false,
  };
}

export function isInvoiceDraft(status) {
  return resolveInvoiceStatus(status) === "draft";
}

/**
 * Draft invoices open in the Review editor.
 * Sent / paid / archived open on Summary (management / read-only).
 */
export function shouldOpenInvoiceInReview(status) {
  return isInvoiceDraft(status);
}

/**
 * Canonical Hub navigation target from invoice status.
 * Draft → editing (review). Everything else → management (summary).
 */
export function resolveInvoiceHubView(status) {
  return shouldOpenInvoiceInReview(status) ? "review" : "summary";
}

/**
 * Invoice Review workspace actions (draft only).
 * @param {string} status
 * @param {{ hasProject?: boolean }} [options]
 */
export function getInvoiceReviewActions(status, options = {}) {
  const inReview = shouldOpenInvoiceInReview(status);
  const hasProject = options.hasProject !== false;

  return {
    editLines: inReview,
    batchEdit: inReview,
    editProjectDiscount: inReview,
    editGoodwill: inReview,
    editReviewNotes: inReview,
    editTax: inReview,
    editNotes: inReview,
    editInvoiceNumber: inReview,
    editClientReference: inReview,
    previewInvoice: true,
    exportPdf: false,
    reseedBillingPeriod: inReview && hasProject,
    markSent: inReview,
    markPaid: false,
    reversePayment: false,
    reopenToDraft: false,
    archive: false,
    deleteDraft: inReview,
  };
}
